import "@/App.css";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Gallery from "@/components/landing/Gallery";
import Differentials from "@/components/landing/Differentials";
import CTASection from "@/components/landing/CTASection";
import Reviews from "@/components/landing/Reviews";
import Location from "@/components/landing/Location";
import Footer from "@/components/landing/Footer";
import FloatingWhatsapp from "@/components/landing/FloatingWhatsapp";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Differentials />
        <CTASection />
        <Reviews />
        <Location />
      </main>
      <Footer />
      <FloatingWhatsapp />
    </div>
  );
}

export default App;
